import { useEffect, useState } from 'react';
import { resolveVariant, trackExposure, TEST } from '../../utils/experimentAssignment';
import Checkout from '../Checkout/Checkout';

const FLAG_KEY = 'checkout-disclaimer-v2';

// Share of checkout visitors entering the experiment at all. Keep this in sync
// with the flag's rollout in PostHog, since a visitor with cached flags is
// assigned by the flag instead.
const ENROLLED_SHARE = 1.0;

// Share of *enrolled* visitors who see the single Place Order disclosure in
// place of the two consent checkboxes.
const TEST_SHARE = 0.50;

export default function CheckoutExperimentEntry() {
    // Resolved once, synchronously, so the correct page paints on the first
    // render — no gate and no swap.
    const [assignment] = useState(() =>
        resolveVariant({ flagKey: FLAG_KEY, enrolledShare: ENROLLED_SHARE, testShare: TEST_SHARE })
    );

    useEffect(() => {
        trackExposure(FLAG_KEY, assignment.variant);
    }, [assignment.variant]);

    return <Checkout consentVariant={assignment.variant === TEST} />;
}
